<div id="page-contents">
  @if (!pageContents) {
    <div class="h-100">
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-border text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  } @else {
    <div [style]="style" class="d-flex align-items-center">
      <div class="container">
        <h1>{{ pageContents?.title ?? 'Error' }}</h1>
      </div>
    </div>
    <div class="container py-5">
      @if (pageContents) {
        <div>
          <div [innerHTML]="pageContents.body"></div>
        </div>
      } @else {
        <h2>Template Will Show</h2>
        <p>
          Whenever there is a failure to connect to the database.
        </p>
      }
      @for (section of pageContents?.sections; track section) {
        @if ((section.profileBios && section.profileBios.length > 0) || (section.sponsors && section.sponsors.length > 0) || (section.pdfFiles && section.pdfFiles.length > 0)) {
          <div class="pt-5">
            <h2 class="pb-3"><strong>{{section.name | uppercase}}</strong></h2>
            <div class="row">
              @for (profile of section.profileBios; track profile) {
                <div class="col-6 col-md-6 col-lg-4 pb-5"
                  >
                  <img [attr.srcset]="profile.imageUrl"
                    class="profile-img"
                    [attr.alt]="profile.imageFileName"/>
                    <div class="col-sm-10 mt-3">
                      <p class="mt-2">
                        <strong>{{ profile.name }}</strong><br />
                        @if (profile.position) {
                          <b>{{ profile.position }}</b><br />
                        }
                        @if (profile.businessOrgName) {
                          {{ profile.businessOrgName }}<br />
                        }
                        @if (profile.email) {
                          {{ profile.email }}<br />
                        }
                        @if (profile.location) {
                          {{ profile.location }}
                        }
                      </p>
                    </div>
                  </div>
                }
              </div>
              <div class="row pb-3 d-flex flex-wrap justify-content-center" style="gap: 1rem;">
                @for (sponsor of section.sponsors; track sponsor) {
                  <a [attr.href]="sponsor.imageHrefUrl" class="img-container" target="_blank">
                    <img [attr.src]="sponsor.imageUrl"
                      class="card-img-top"
                      [attr.alt]="sponsor.name"
                      [attr.title]="sponsor.name"
                      />
                    </a>
                  }
                </div>
                <div class="row pb-3">
                  @for (files of section.pdfFiles; track files) {
                    <div class ="col-sm-10 break"
                      >
                      <p>
                        <a href="{{ files.fileUrl }}">{{ files.fileDisplayName }}</a>
                      </p>
                    </div>
                  }
                </div>
              </div>
            }
          }
          @if (isBillPositions) {
            <div>
              <div class="row">
                <label for="session" class="col-12 mb-3">
                  Select a legislative session:
                  <select style="color: black;" class="mt-sm-0 mt-1" name="session" id="session">
                    @for (session of sessionOptions; track session) {
                      <option [value]="session.value" [selected]="session.value === '25'">
                        {{ session.label }}
                      </option>
                    }
                  </select>
                </label>
                <h3 class="col-12" id="search-label">Search via Bill Number or Keyword:</h3>
                <div class="col-sm-9 col-12">
                  <input
                    class="w-100"
                    style="color: #002a60;"
                    type="text"
                    name="s"
                    size="40"
                    aria-labelledby="search-label"
                    />
                  </div>
                  <div class="col-sm-3 col-12">
                    <button
                      style="color: #002a60; background-color: transparent; cursor: pointer;"
                      class="mt-sm-0 mt-2"
                      type="button"
                      onclick="runCTsearch()"
                      >
                      Search
                    </button>
                  </div>
                  <input
                    type="hidden"
                    name="idkey"
                    value="c14cfa79-14ae-41bd-8264-461358e96ddd"
                    />
                    <fieldset class="col-12">
                      <legend class="visually-hidden">Search By:</legend>
                      <label for="radioButton">
                        <input
                          id="radioButton"
                          type="radio"
                          name="t"
                          value="bill"
                          checked="checked"
                          />
                          Bill Number
                        </label>
                        <label for="keywordInput" class="ms-3">
                          <input
                            id="keywordInput"
                            style="color: #002a60;"
                            type="radio"
                            name="t"
                            value="keyword"
                            />
                            Keyword
                          </label>
                        </fieldset>
                        <label class="col-12 mt-3" for="selectOpt">
                          Report Subject:
                          <select
                            style="font-size: 16px;"
                            class="ctselect"
                            id="selectOpt"
                            onchange="CTselect()"
                            >
                            <option value="https://ctweb.capitoltrack.com/public/publish.aspx?id=17dce531-a079-4846-8b7d-0803cf3e50c8">
                              All Tracked
                            </option>
                            <option value="https://ctweb.capitoltrack.com/public/publish.aspx?id=d4f62ed2-b867-416e-b0e0-4350b961560f">
                              Support
                            </option>
                          </select>
                        </label>
                      </div>
                      <div class="mt-3" style="text-align: right;">
                        <!-- <button onclick="window.print()">Print this page</button> -->
                        <button
                          style="color: #282860; background-color: transparent; cursor: pointer;"
                          onclick="CTprintview()"
                          >
                          Print View
                        </button>
                      </div>
                      <p>
                        <!-- the src of the iframe begins with the default report to display , this should match the first report listed in above select statement -->
                        <!--
                        NOTE ON UPGRADE TO ANGULAR 15:
                        Existing <iframe> instances might have security-sensitive attributes applied to them as an attribute or property binding. These security-sensitive attributes can occur in a template or in a directive's host bindings. Such occurrences require an update to ensure compliance with the new and stricter rules about <iframe> bindings. For more information, see the error page.
                        -->
                        <iframe
                          aria-label="Data"
                          align="top"
                          frameborder="0"
                          height="800"
                          id="ct-iframe"
                          src="https://ctweb.capitoltrack.com/public/publish.aspx?id=17dce531-a079-4846-8b7d-0803cf3e50c8"
                          width="100%"
                        ></iframe>
                      </p>
                    </div>
                  }
                </div>
              }
            </div>
